import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IDestination, IDestinationInitialState } from "./destinationModel";
import {
  ActiveInactiveDestination,
  DestinationImageUpload,
  createDestination,
  deleteDestination,
  getAllActiveDestination,
  getAllDestination,
  getDestinationByID,
  updateDestination,
} from "./services/destination.services";

const initialState: IDestinationInitialState = {
  loading: false,
  formLoading: false,
  error: "",
  DestinationID: null,
  DestinationList: [],
  DestinationDetail: {
    ID: null,
    Title: "",
    Description: "",
    DestinationURL: "",
    DestinationImg: "",
    DestinationLogo: "",
    IsActive: 1,
  },
};

const destinationSlice = createSlice({
  name: "destination",
  initialState,
  reducers: {
    clearDestinationDetails: (state) => {
      state.DestinationDetail = initialState.DestinationDetail;
    },
    setDestinationID: (state, action) => {
      state.DestinationID = action.payload;
    },
    clearDestinationID: (state) => {
      state.DestinationID = initialState.DestinationID;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAllDestination.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllDestination.fulfilled,
      (state, action: PayloadAction<IDestination[]>) => {
        state.loading = false;
        state.DestinationList = action.payload || [];
      }
    );
    builder.addCase(getAllDestination.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.DestinationList = [];
    });
    builder.addCase(createDestination.pending, (state) => {
      state.loading = false;
      state.error = "";
    });
    builder.addCase(createDestination.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(createDestination.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(updateDestination.pending, (state) => {
      state.loading = false;
      state.error = "";
    });
    builder.addCase(updateDestination.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(updateDestination.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(deleteDestination.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(deleteDestination.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(deleteDestination.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(getDestinationByID.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(getDestinationByID.fulfilled, (state, action: any) => {
      state.loading = false;
      state.DestinationDetail = action.payload;
    });
    builder.addCase(getDestinationByID.rejected, (state, action) => {
      state.loading = false;
      state.DestinationDetail = initialState.DestinationDetail;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(getAllActiveDestination.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllActiveDestination.fulfilled,
      (state, action: PayloadAction<IDestination[]>) => {
        state.loading = false;
        state.DestinationList = action.payload || [];
      }
    );
    builder.addCase(getAllActiveDestination.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.DestinationList = [];
    });
    builder.addCase(ActiveInactiveDestination.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(ActiveInactiveDestination.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(ActiveInactiveDestination.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });

    // IMAGE UPLOAD
    builder.addCase(DestinationImageUpload.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(DestinationImageUpload.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(DestinationImageUpload.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
  },
});

export const { clearDestinationDetails, clearDestinationID, setDestinationID } =
  destinationSlice.actions;
export default destinationSlice.reducer;
